import Popover from "@hydrologiq/shared/chakra/Popover"
import { Asset } from "@hydrologiq/gql-experience/graphql"
import StatusBadge from "@hydrologiq/shared/asset/status/StatusBadge"
import EntityPopoverList from "@hydrologiq/shared/components/popovers/EntityPopoverList"
import DataConnectionIndicator from "@hydrologiq/shared/data-connections/DataConnectionIndicator"

interface AssetsPopupCellProps {
  assetCount: number
  assets: Asset[]
  name?: string
}

function AssetsPopupCell({ assetCount, assets, name = "System" }: AssetsPopupCellProps) {
  const items = assets.map((asset: any) => ({
    id: asset.id,
    name: asset.name || "Unnamed Asset",
    href: `/assets/${asset.id}`,
    openExternal: true,
    prefix: <DataConnectionIndicator asset={asset} />,
    badge: asset.status ? <StatusBadge asset={asset} minWidth="5.25rem" /> : undefined,
  }))

  return (
    <Popover
      placement="bottom-end"
      additionalContent={assetCount.toString()}
      ariaLabel={`View ${assetCount} assets`}
      width="max-content"
      minWidth="22.5rem"
      maxWidth="min(45rem, calc(100vw - 3rem))"
      disabled={assetCount === 0}
      showArrow={true}
      closeOnOutside
    >
      <EntityPopoverList
        title="Assets"
        count={assetCount}
        items={items}
        emptyText="No assets in system"
      />
    </Popover>
  )
}

export default AssetsPopupCell
